import { z } from 'zod'

export const trainerInvoiceExceptionResponseSchema = z.record(z.unknown())
export type TrainerInvoiceExceptionResponse = z.infer<typeof trainerInvoiceExceptionResponseSchema>
